import { Box, Button } from '@mui/material';

interface Props {
  disabled?: boolean;
  stepAtual?: any;
  totalSteps?: any;
  onSendApproved?: () => void;
  onAdvanced?: () => void;
  onBack?: () => void;
  onSaveDraft?: () => void;
  onConfirmSave?: () => void;
}

const ButtonForm: React.FC<Props> = ({
  disabled,
  stepAtual,
  totalSteps,
  onSendApproved,
  onAdvanced,
  onBack,
  onSaveDraft,
  onConfirmSave,
}) => {

  return (
    <Box
      display="flex"
      justifyContent="center"
      gap={2}
      mt={4}
      width="100%"
    >
      {/* voltar um formulario */}
      {onBack && (
        <Button
          variant='text'
          color='primary'
          onClick={onBack}
          sx={{
            height: 40,
            borderRadius: "4px",
            textTransform: "uppercase",
            fontSize: "14px",
            fontWeight: 600,
            px: 2.5,
          }}
        >
          Voltar
        </Button>
      )}

      {/* salvar rascunho */}
      {onSaveDraft && (
        <Button
          variant="outlined"
          color="primary"
          onClick={onSaveDraft}
          disabled={disabled}
          sx={{
            height: 40,
            borderRadius: "4px",
            textTransform: "uppercase",
            fontSize: "14px",
            fontWeight: 600,
            px: 2.5,
            borderWidth: 1.5,
            "&:hover": {
              borderWidth: 1.5,
            },
          }}
        >
          Salvar Rascunho
        </Button>
      )}

      {/* confirmar e salvar */}
      {onConfirmSave && (
        <Button
          variant="contained"
          onClick={onConfirmSave}
          disabled={disabled}
          sx={{
            height: 40,
            borderRadius: "4px",
            textTransform: "uppercase",
            fontSize: "14px",
            fontWeight: 700,
            px: 2.5,
            boxShadow: "none",
            bgcolor: "#0048B6",
            color: "#fff",
            "&:hover": { bgcolor: "#0048B6" },
          }}
        >
          Confirmar e Salvar
        </Button>
      )}

      {/* salvar e avançar / enviar para aprovação */}
      {typeof stepAtual !== "undefined" &&
        (stepAtual === totalSteps ? (
          <Button
            variant="contained"
            type="submit"
            disabled={disabled}
            onClick={onSendApproved}
            sx={{
              height: 40,
              borderRadius: "4px",
              textTransform: "uppercase",
              fontSize: "14px",
              fontWeight: 700,
              px: 3,
              boxShadow: "none",
              bgcolor: "#0048B6",
              color: "#fff",
              "&:hover": { bgcolor: "#0048B6" },
            }}
          >
            Enviar para aprovação
          </Button>
        ) : (
          <Button
            variant="contained"
            type="submit"
            disabled={disabled}
            onClick={onAdvanced}
            sx={{
              height: 40,
              borderRadius: "4px",
              textTransform: "uppercase",
              fontSize: "14px",
              fontWeight: 700,
              px: 3,
              boxShadow: "none",
              bgcolor: "#0048B6",
              color: "#fff",
              "&:hover": { bgcolor: "#0048B6" },
            }}
          >
            Salvar e Avançar
          </Button>
        ))}

    </Box>
  )
}

export default ButtonForm;
